import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit } from "@angular/core";
import { MatSnackBar } from "@angular/material/snack-bar";
import { DomSanitizer } from "@angular/platform-browser";
import { Router } from '@angular/router';
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { BaseSiteService, CmsService, LanguageService, OccEndpointsService } from "@spartacus/core";
import { UserAccountFacade } from "@spartacus/user/account/root";
import { Subscription } from "rxjs";
import { take } from "rxjs/operators";
import { SharedService } from "src/app/shared/services/shared.service";
import { ProductUtils } from "src/app/shared/utils/productUtils";
import { DisplayImgComponent } from "../display-img/display-img.component";
import { NotificationBarComponent } from "../notification-bar/notification-bar.component";
import { ResourcesService } from "../resources.service";

declare const require: any;

@Component({
  selector: 'app-patient-education',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './patient-education.component.html',
  styleUrls: ['./patient-education.component.scss'],
})
export class PatientEducationComponent implements OnInit, OnDestroy {
  catalogsList: any = [];
  baseUrl = this.occEndPoint.getBaseUrl({
    baseUrl: true,
    prefix: false,
    baseSite: false,
  });
  fileUrl: any;
  baseSiteId = '';
  defaultImg = '';
  catalogsDataSubscription: any;
  userDetails: any;
  userDataSub: Subscription;
  end: number;
  totalOrders = 0;
  curPage = 0;
  pageSize = 18;
  tempCatalogsList: any = [];
  pageRange: any;
  trimStart: number = 0;
  trimEnd: number = 18;
  paginationData = {};
  unitDefaultValue = 1;
  isRequested = false;
  requestedItemList = [];
  productQuantity: any;
  reviewRequestArray = [];
  backToDashboardSub: Subscription;
  categoryTitle: any;
  categoryType: any;
  loggedInDevice:string;

  constructor(
    private readonly service: ResourcesService,
    private readonly occEndPoint: OccEndpointsService,
    private readonly cd: ChangeDetectorRef,
    private readonly modalService: NgbModal,
    private readonly sanitizer: DomSanitizer,
    private readonly lang: LanguageService,
    private readonly user: UserAccountFacade,
    private router: Router,
    private readonly matSnackBar: MatSnackBar,
    private readonly sharedService: SharedService,
    private readonly cmsData: CmsService,
    private baseSiteService: BaseSiteService
  ) { }

  ngOnInit() {
    this.lang.getActive().subscribe((res) => {
      this.getCatalogsList();
    });

    this.userDataSub = this.user.get().subscribe((res) => {
      this.userDetails = res;
    });

    this.service.emitPaginationValue$.subscribe((data) => {
      if (data) {
        this.getCurrentPage(data);
        this.cd.detectChanges();
      }
    });

    this.service.backToDashBoardEmitter.subscribe((data) => {
      if (data) {
        this.matSnackBar.openFromComponent(NotificationBarComponent, {
          data: data.items, panelClass: this.baseSiteId
        });
        this.reviewRequestArray.push(data.items);
        this.sharedService.removeSessionStorage('isClickedBackToDashboard');
      }
    })
    this.baseSiteService
      .getActive()
      .pipe(take(1))
      .subscribe((res) => {
        this.baseSiteId = res;
        this.defaultImg =
          `../../../assets/icons/${this.baseSiteId}/sanofi_missing_product.jpg`;
      });

     this.loggedInDevice =  ['iPhone', 'Pixel', 'SM-G9'].some(device => navigator.userAgent.includes(device))  ? 'mobile' : 'others';
  }

  getCatalogsList() {
    this.service.getCatalogTypes('mostpopular');
    this.catalogsDataSubscription = this.service.catalogs$.subscribe((res) => {
      if (res !== null) {
        if (res && res.categoryData && res.categoryData.length) {
          this.trimStart = 0;
          this.trimEnd =
            res.categoryData[0].products.length <= 18
              ? res.categoryData[0].products.length
              : 18;
          this.pageSize = this.trimEnd;
          this.curPage = 0;

          this.catalogsList = res.categoryData[0].products;
          this.tempCatalogsList = res.categoryData[0].products;

          this.cd.detectChanges();
          this.totalOrders = res.categoryData[0].products.length;
        }
        this.getCurrentPage('next');
        // this.paginationData['pageRange'] = this.pageRange;
        // this.paginationData['totalOrders'] = this.totalOrders;
        // this.paginationData['curPage'] = this.curPage;
        // this.paginationData['numberOfPages'] = this.numberOfPages();
        // this.service.setPaginationValues(this.paginationData);
        this.setPagination();
        let value = this.sharedService.getSessionStorage('isClickedBackToDashboard');
        if (value === true) {
          if (this.service.backtoDashboadItems.length > 0) {
            let tempList = [];
            tempList.push(this.service.backtoDashboadItems[0]);
            for (let i = 0; i < tempList[0].length; i++) {
              let isFound = this.requestedItemList.find(x => x.code === tempList[0][i].code);
              if (!isFound) {
                this.requestedItemList.push(tempList[0][i]);
              }
              const inputElement = document.getElementById(
                `prodQuantity${tempList[0][i].code}`
              ) as HTMLInputElement;
              if (inputElement) {
                inputElement.value = tempList[0][i].units;
                ProductUtils.alterNewQuantity(null, tempList[0][i].code, tempList[0][i].quantityPerUnit, 'doses')
              }
            }
          }
        }
        this.cd.detectChanges();
      }
      this.categoryType = localStorage.getItem('selectedCategoryType');
      let tempCategoryList = this.service.categoryTypeList;
      if (tempCategoryList && tempCategoryList.length > 0) {
        for (let i = 0; i < tempCategoryList[0].length; i++) {
          if (localStorage.getItem('selectedCategoryType')) {
            if (tempCategoryList[0][i]['id'] === localStorage.getItem('selectedCategoryType')) {
              this.categoryTitle = tempCategoryList[0][i]['title'];
              this.cd.detectChanges();
              return;
            }
            for (let category in tempCategoryList[0][i].subcategories) {
              if (tempCategoryList[0][i].subcategories[category]['id'] === localStorage.getItem('selectedCategoryType')) {
                this.categoryTitle = tempCategoryList[0][i].subcategories[category]['title'];
                this.cd.detectChanges();
                return;
              }
            }
          }
        }
      }

    });
  }
  ngOnDestroy() {
    this.catalogsDataSubscription?.unsubscribe();
    this.sharedService.removeSessionStorage('isClickedBackToDashboard');
  }

  downloadFile(downloadUrl, name) {
    if (downloadUrl && downloadUrl.url) {
      const pdfUrl = `${this.baseUrl}${downloadUrl.url}`;
      const pdfName = `${name}.pdf`;
      const FileSaver = require('file-saver');
      FileSaver.saveAs(pdfUrl, pdfName);
    }
  }

  openNewModalPopup(image) {
    const modalRef = this.modalService.open(DisplayImgComponent, {
      size: 'md',
      scrollable: false,
      windowClass: 'patient-edu-modal',
    });
    const img = `${this.baseUrl}${image[0].url}`;
    modalRef.componentInstance.image = img;
  }

  getImage(image) {
    let tempImg;
    if (image && image.length > 0) {
      if (image[0] && image[0].url) {
        tempImg = `${this.baseUrl}${image[0].url}`;
      } else {
        tempImg = this.defaultImg;
      }
    }
    else {
      tempImg = this.defaultImg;
    }
    return tempImg;

  }

  getCurrentPage(type) {
    if (type === 'prev') {
      this.curPage -= 1;
    } else if (type === 'next') {
      this.curPage += 1;
    }
    this.trimStart = (this.curPage - 1) * this.pageSize;
    this.trimEnd = this.trimStart + this.pageSize;

    const itemsPerPage = 18;
    if (itemsPerPage < this.totalOrders) {
      this.end = itemsPerPage * this.curPage;
      if (this.end > this.totalOrders) {
        this.end = this.totalOrders;
      }
    }
    else {
      this.end = this.totalOrders;
    }
    this.trimEnd = this.trimStart + this.pageSize;
    if (this.totalOrders > 0) {
      this.pageRange = `${this.trimStart + 1}-${this.end}`;
    } else {
      this.pageRange = `0`;
    }

    this.setPagination();
  }

  numberOfPages() {
    if (this.catalogsList && this.totalOrders && this.pageSize > 0) {
      return Math.ceil(this.totalOrders / this.pageSize);
    } else {
      return 1;
    }
  }

  setPagination() {
    this.paginationData['pageRange'] = this.pageRange;
    this.paginationData['totalOrders'] = this.totalOrders;
    this.paginationData['curPage'] = this.curPage;
    this.paginationData['numberOfPages'] = this.numberOfPages();
    this.service.setPaginationValues(this.paginationData);
  }

  performQuantityComputation(
    operator,
    idData,
    quantityPerUnit = 1,
    unitType,
    product
  ): void {
    ProductUtils.alterNewQuantity(operator, idData, quantityPerUnit, unitType);
    const inputElement = document.getElementById(
      `prodQuantity${product.code}`
    ) as HTMLInputElement;
    const buttonElement = document.getElementById(
      `btn${product.code}`
    ) as HTMLButtonElement;

    if (inputElement.classList.contains('quantity-error')) {
      inputElement.classList.remove('quantity-error');
      inputElement.classList.add('no-error');
      buttonElement.removeAttribute('disabled');
    }
  }

  requestItem() {
    this.matSnackBar.openFromComponent(NotificationBarComponent, {
      data: this.requestedItemList,
    });
    // this.matSnackBar.open('test');
    this.isRequested = true;
  }

  navigateRequestPage() {
    this.service.requestItemValues.next(this.requestedItemList);
    this.router.navigate(['resources/category/requestResourcespage']);
    this.service.backToDashBoardEmitter.next(null);
    localStorage.setItem('requestedItemList', JSON.stringify(this.requestedItemList));
  }

  addRequestItem(product, units, popOver, calValue?) {

    const inputElement = document.getElementById(
      `prodQuantity${product.code}`
    ) as HTMLInputElement;
    const buttonElement = document.getElementById(
      `btn${product.code}`
    ) as HTMLButtonElement;

    if (inputElement.value > product.maxAllowedQuantity) {
      inputElement.classList.add('quantity-error');
      buttonElement.setAttribute('disabled', 'true');
      if (popOver.isOpen())
        popOver.close();
      popOver.open();
      this.productQuantity = product.maxAllowedQuantity;
      return;
    }
    this.isRequested = true;
    const list = {
      'code': product?.code,
      'units': inputElement.value,
      'calValue': parseInt(inputElement.value) * (product.postersQuantityPerUnit ? parseInt(product?.postersQuantityPerUnit) : 1),
      'url': product?.images ? (product?.images.length > 0 && product?.images[0] ? this.baseUrl + product.images[0].url : this.defaultImg)
        : this.defaultImg,
      'name': product?.name,
      'desc': product?.description,
      'maxAllowedQuantity': product?.maxAllowedQuantity,
      'quantityPerUnit': product?.postersQuantityPerUnit ? product?.postersQuantityPerUnit : 1,
      'unit': product?.unit
    }
    let isFound = this.requestedItemList.find(x => x.code === product?.code);
    if (isFound) {
      this.requestedItemList.splice(this.requestedItemList.findIndex(x => x.code === product.code), 1);
    }
    this.requestedItemList.push(list);
    this.matSnackBar.openFromComponent(NotificationBarComponent, {
      data: this.requestedItemList, panelClass: this.baseSiteId
    });
    this.service.backtoDashboadItems.splice(0, this.service.backtoDashboadItems.length);
    this.sharedService.removeSessionStorage('isClickedBackToDashboard');
  }

  goToLogin() {
    //this.router.navigate(['login']);
    $('.headerLoginSection').show();
  }
}